import { defineStore } from 'pinia';
import { ref } from 'vue';

export type SnackbarType = 'success' | 'error' | 'warning' | 'info' | 'default';

export interface SnackbarOptions {
  text: string;
  title?: string;
  type?: SnackbarType;
  timeout?: number;
  location?: 'top' | 'bottom' | 'top left' | 'top right' | 'bottom left' | 'bottom right';
  color?: string;
}

export const useSnackbarStore = defineStore('snackbar', () => {
  const show = ref(false);
  const text = ref('');
  const title = ref('');
  const type = ref<SnackbarType>('default');
  const timeout = ref(4000);
  const location = ref<'top' | 'bottom' | 'top left' | 'top right' | 'top center' | 'bottom left' | 'bottom right' | 'bottom center'>('top center');
  const color = ref<string | undefined>(undefined);

  const showSnackbar = (options: SnackbarOptions) => {
    text.value = options.text;
    title.value = options.title || '';
    type.value = options.type || 'default';
    timeout.value = options.timeout || 4000;
    location.value = options.location || 'top center';
    color.value = options.color || getColorByType(type.value);
    show.value = true;
  };

  const hideSnackbar = () => {
    show.value = false;
  };

  const getColorByType = (type: SnackbarType): string => {
    const colorMap: Record<SnackbarType, string> = {
      success: 'success',
      error: 'error',
      warning: 'warning',
      info: 'info',
      default: 'secondary',
    };
    return colorMap[type];
  };

  return {
    show,
    text,
    title,
    type,
    timeout,
    location,
    color,
    showSnackbar,
    hideSnackbar,
  };
});
